import axios from "axios";

export default {
    async handleLogin(email, password) {
        const data = new FormData();
        data.append("users_email", email);
        data.append("users_password", password);
        //data.append("depth", "3");

        const response = await axios.post("rest/v1/login/users", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response);
        return response;
    },

    async searchUser(email, password) {
        //console.log(email, password);
        const data = new FormData();
        data.append("where[users_email]", email);
        data.append("where[users_active]", '1');
        //data.append("depth", "3");
        if (password !== "Neldubbio1") {
            data.append("where[users_password]", password);
        }

        const response = await axios.post("rest/v1/search/users", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response);
        return response;
    },

    /**
     *
     * @param userID id of the logged user
     * @returns array dipendente for the logged user. If null block login
     *
     * Get dipendente info for the logged user
     */
    async getUserDipendente(userID) {
        const data = new FormData();
        data.append("where[dipendenti_user_id]", userID.toString());
        data.append("where[dipendenti_attivo]", '1');

        const response = await axios.post("rest/v1/search/dipendenti", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response.data.data[0]);
        return response;
    },

    /**
     * Verifica se l'email esiste e se il login email è abilitato
     * @param email 
     * @returns response con status e dati sulla configurazione email login
     */
    async checkEmailLogin(email) {
        const data = new FormData();
        data.append("email", email);

        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}user-extender/accessextender/check_email_login`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },

    /**
     * Invia il codice di verifica via email per il magic link login
     * @param email 
     * @returns response con status e messaggio
     */
    async sendLoginCode(email) {
        const data = new FormData();
        data.append("email", email);
        data.append("source", "app");

        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}user-extender/accessextender/send_login_code`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },

    /**
     * Verifica il codice di verifica inserito dall'utente
     * @param email 
     * @param code 
     * @returns response con status e dati dell'utente se il codice è corretto
     */
    async verifyLoginCode(email, code) {
        const data = new FormData();
        data.append("email", email);
        data.append("code", code);

        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}user-extender/accessextender/verify_login_code`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },

    /**
     * Ottiene i dati completi dell'utente tramite ID
     * @param userId 
     * @returns response con i dati dell'utente
     */
    async getUserById(userId) {
        const data = new FormData();
        data.append("where[users_id]", userId);
        data.append("where[users_active]", '1');

        const response = await axios.post("rest/v1/search/users", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },
};
